import { useOutletContext } from "react-router-dom";

import SuperAdminDistributionPipelineSettingsView from "../../views/SuperAdminDistributionPipelineView/SuperAdminDistributionPipelineSettingsView";

export default function SuperAdminDistributionPipelineSettings() {
	const context = useOutletContext();

	return <SuperAdminDistributionPipelineSettingsView {...context} />;
}
